import { toast } from "sonner";

// Shown when a record generated from an Optro-linked session could not have
// its Optro-owned fields read after creation (the backend's
// optro_fields_failed). The record itself was created; Resync from Optro on
// its page fills the fields in.
type OptroLinkedRecord = "control" | "workStep";

const OPTRO_FIELDS_NOT_CARRIED_COPY: Record<OptroLinkedRecord, string> = {
  control:
    "We couldn't bring in Cycle, Process and Control Owner from Optro. Use Resync from Optro on this control to fill them in.",
  workStep:
    "We couldn't bring in Audit, Section, Subsection and Preparer from Optro. Use Resync from Optro on this work step to fill them in.",
};

export const toastOptroFieldsNotCarried = (record: OptroLinkedRecord) => {
  toast.warning(OPTRO_FIELDS_NOT_CARRIED_COPY[record], { duration: 10000 });
};
